<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="toolbar">
      <v-toolbar-title>Publication Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="publication_list"
      class="elevation-1 mytable"
      dense
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small
                >Add Publication Details</v-btn
              >
            </template>
            <v-card>
              <v-card-title class="toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        :items="publication_list"
                        v-model="editedItem.title"
                        label="Title"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        :items="publication_list"
                        v-model="addedItem.title"
                        label="Title"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        rounded
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            v-model="addedItem.dateFormat"
                            @blur="date = parseDate(addedItem.dateFormat)"
                            v-on="on"
                            rounded
                            outlined
                            label="Date of Publication"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        rounded
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            dense
                            v-model="editedItem.dateFormat"
                            @blur="date = parseDate(addedItem.dateFormat)"
                            v-on="on"
                            rounded
                            outlined
                            label="Date of Publication"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="addedItem.conf_journal"
                        label="Conference Journal"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="editedItem.conf_journal"
                        label="Conference Journal "
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        type="number"
                        outlined
                        v-model="addedItem.ci_no"
                        label="Citation Number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        type="number"
                        outlined
                        v-model="editedItem.ci_no"
                        label="Citation Number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        type="number"
                        outlined
                        v-model="addedItem.index_value"
                        label="Index value"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        type="number"
                        outlined
                        v-model="editedItem.index_value"
                        label="Index value"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="addedItem.isbn_no"
                        label="ISBN Number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="editedItem.isbn_no"
                        label="ISBN Number"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="addedItem.publication_link"
                        label="Publication Link"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="editedItem.publication_link"
                        label="Publication Link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="addedItem.publication_type"
                        :items="publication_level_list"
                        item-text="publication_type"
                        item-value="id"
                        label="Publication Level"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="editedItem.publication_type"
                        :items="publication_level_list"
                        item-text="publication_type"
                        label="Publication Level"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="addedItem.publication_category"
                        :items="publication_category_list"
                        item-text="publication_category"
                        item-value="id"
                        label="Select Publication Category"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="editedItem.publication_category"
                        :items="publication_category_list"
                        item-text="publication_category"
                        label="Select Publication Category"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="addedItem.ay"
                        :items="academic_year_list"
                        item-text="ay"
                        item-value="id"
                        label="Select Academic Year"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="editedItem.ay"
                        :items="academic_year_list"
                        item-text="ay"
                        label="Select Academic Year"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="addedItem.publication_index_type"
                        :items="publication_index_type_list"
                        item-text="publication_index_type"
                        item-value="id"
                        label="Select Index type"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        v-model="editedItem.publication_index_type"
                        :items="publication_index_type_list"
                        item-text="publication_index_type"
                        label="Select Publication Index type"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-checkbox
                        dense
                        :items="publication_list"
                        v-model="addedItem.isfirstauthor"
                        color="success"
                        label="Is First Author?"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-checkbox
                        dense
                        :items="publication_list"
                        v-model="editedItem.isfirstauthor"
                        color="success"
                        label="Is First Author?"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" @click="close">Cancel</v-btn>
                <v-btn class="button" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.publication_link="{ item }">
        <div>
          <span v-if="item.publication_link != null">
          <a :href="item.publication_link" target="_blank"> link</a>
        </span>
        <span v-else> NA </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon
              color="error"
              class="delete-v-icon mr-2"
              @click="deleteItem(item)"
              >delete</v-icon
            >
          </v-avatar>
        </div>
      </template>

      <!-- <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
        </template> -->
    </v-data-table>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      overlay: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      //dateFormat: "",
      date: new Date().toISOString().substr(0, 10),
      menu1: false,

      errorMsg: {
        degree_name: false,
      },
      headers: [
        {
          text: "Sr. No.",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title",
        },
        {
          text: "Publication Date",
          align: "left",
          sortable: false,
          value: "dateFormat",
        },
        {
          text: "Conference Journal",
          align: "left",
          sortable: false,
          value: "conf_journal",
        },
        {
          text: "Citation Number",
          align: "left",
          sortable: true,
          value: "ci_no",
        },

        {
          text: "Index Value",
          align: "left",
          sortable: true,
          value: "index_value",
        },
        {
          text: "ISBN No.",
          align: "left",
          sortable: true,
          value: "isbn_no",
        },
        {
          text: "Publication Link",
          align: "left",
          sortable: true,
          value: "publication_link",
        },
        {
          text: "Publication Level",
          align: "left",
          sortable: true,
          value: "publication_type",
        },
        {
          text: "Publication Category",
          align: "left",
          sortable: true,
          value: "publication_category",
        },
        {
          text: "Academic Year",
          align: "left",
          sortable: true,
          value: "ay",
        },
        {
          text: "Index Type",
          align: "left",
          sortable: true,
          value: "publication_index_type",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      editedIndex: -1,
      publication_list: [],
      publication_level_list: [],
      publication_category_list: [],
      publication_index_type_list: [],
      academic_year_list: [],
      addedItem: {
        instid: this.instid,
        title: null,
        dateFormat: "",
        conf_journal: null,
        ci_no: null,
        index_value: null,
        isbn_no: null,
        publication_link: null,
        publication_category: null,
        publication_type: null,
        ay: null,
        isfirstauthor: false,
      },
      editedItem: {
        instid: "",
        id: "",
        title: null,
        dateFormat: null,
        conf_journal: null,
        ci_no: null,
        index_value: null,
        isbn_no: null,
        publication_link: null,
        publication_category: null,
        publication_type: null,
        ay: null,
        isfirstauthor: true,
      },
    };
  },
  // watch: {
  //   instid() {
  //     this.getData();
  //   },
  //   overlay(val) {
  //     val = () => {
  //       this.overlay = false;
  //     };
  //   },

  // },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Publication Details"
        : "Edit Publication Details";
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    makeNull()
    {
      this.editedItem.title = null;
      this.editedItem.dateFormat = null;
      this.editedItem.conf_journal = null;
      this.editedItem.ci_no = null;
      this.editedItem.index_value = null;
      this.editedItem.isbn_no = null;
      this.editedItem.publication_link = null;
      this.editedItem.publication_category = null;
      this.editedItem.publication_type = null;
      this.editedItem.ay = null;
      this.editedItem.isfirstauthor = null;
    },
    getData() {
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getEmployeePublication", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.publication_list = res.data.publication_list;
            this.publication_level_list = res.data.publication_level_list;
            this.publication_category_list = res.data.publication_category_list;
            this.publication_index_type_list =
              res.data.publication_index_type_list;
            this.academic_year_list = res.data.academic_year_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";

        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.publication_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    isValidated() {
      if (this.editedItem.title) {
        return true;
      } else {
        if (!this.editedItem.title) {
          this.errorMsg.title = true;
        }

        return false;
      }
    }, // .....end of isValidated()
    save() {
      if (this.editedIndex > -1) {
        this.editedItem.instid = this.instid;
        if (this.isValidated()) {
          axios
            .post("/EmployeeProfile/editEmployeePublication", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                if (res.data.status.code == "SUCCESS") {
                  this.showSnackbar(
                    "#4caf50",
                    "Publications updated successfully..."
                  ); // show snackbar on success
                  this.makeNull()
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar(
                    "#b71c1c",
                    "Publication details already present!!!"
                  );
                  this.makeNull()
                }
                this.getData();
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              // this.title = null;
              // this.dateFormat = "";
              // this.conf_journal = null;
              // this.ci_no = null;
              // this.index_value = null;
              // this.isbn_no = null;
              // this.publication_link = null;
              // this.publication_category = null;
              // this.publication_type = null;
              // this.ay = null;
              // this.isfirstauthor = null;
              this.makeNull()
            });

          this.dialog = false;
        }
      } else {
        if (this.addedItem.title == null || this.addedItem.title == "") {
          this.showSnackbar("#b71c1c", "Please Enter Title!!!");
        }else if (this.addedItem.dateFormat == null || this.addedItem.dateFormat == "") {
          this.showSnackbar("#b71c1c", "Please select Publication Date!!!");
        }
        else if (
          this.addedItem.publication_type == null ||
          this.addedItem.publication_type == ""
        ) {
          this.showSnackbar("#b71c1c", "Please Enter Publication Type!!!");
        } else if (
          this.addedItem.publication_category == null ||
          this.addedItem.publication_category == ""
        ) {
          this.showSnackbar("#b71c1c", "Please Enter Publication Category!!!");
        } else if (this.addedItem.ay == null || this.addedItem.ay == "") {
          this.showSnackbar("#b71c1c", "Please Enter Academic Year!!!");
        } else if (
          this.addedItem.publication_index_type == null ||
          this.addedItem.publication_index_type == ""
        ) {
          this.showSnackbar(
            "#b71c1c",
            "Please Enter Publication Index Type!!!"
          );
        } else {
          axios
            .post("/EmployeeProfile/saveEmployeePublication", this.addedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                //   this.fees_component_list.push(this.addedItem);
                this.showSnackbar(
                  "#4caf50",
                  "Publication Details added successfully..."
                ); // show snackbar on success
                this.getData();
                this.dialog = false;
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Publication Details already present!!!"
                );
                // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              // this.title = null;
              // this.dateFormat = "";
              // this.conf_journal = null;
              // this.ci_no = null;
              // this.index_value = null;
              // this.isbn_no = null;
              // this.publication_link = null;
              // this.publication_category = null;
              // this.publication_type = null;
              // this.ay = null;
              // this.isfirstauthor = null;
              this.makeNull()
            });
          this.dialog = false;
        }
      }
    },

    deleteItem(item) {
      //alert("in delete : " + item.id);
      var result = confirm("Want to delete?");
      if (result) {
        const formData = {
          instid: this.instid,
          publication_id: item.id,
        };
        axios
          .post("/EmployeeProfile/deleteEmployeePublication", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar(
                  "#4caf50",
                  " Publication data deleted successfully..."
                );
              } else {
                this.showSnackbar("#b71c1c", "Can not delete data!!!");
              }
              this.getData();
            } else {
              this.showSnackbar("#b71c1c", "Please try again!!!");
            }
          })
          .catch((error) => {
            alert("Somthing went wrong!!!");
          })
          .finally(() => {
            // this.comp_load = false;
          });
      }
    },
    close() {
      this.dialog = false;
      this.addedItem.title = null;
      this.addedItem.dateFormat = null;
      this.addedItem.conf_journal = null;
      this.addedItem.ci_no = null;
      this.addedItem.index_value = null;
      this.addedItem.isbn_no = null;
      this.addedItem.publication_link = null;
      this.addedItem.publication_category = null;
      this.addedItem.publication_type = null;
      this.addedItem.publication_index_type = null;
      this.addedItem.ay = null;
      this.addedItem.isfirstauthor = null;

      this.editedItem.title = null;
      this.editedItem.dateFormat = null;
      this.editedItem.conf_journal = null;
      this.editedItem.ci_no = null;
      this.editedItem.index_value = null;
      this.editedItem.isbn_no = null;
      this.editedItem.publication_link = null;
      this.editedItem.publication_category = null;
      this.editedItem.publication_type = null;
      this.editedItem.publication_index_type = null;
      this.editedItem.ay = null;
      this.editedItem.isfirstauthor = null;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  watch: {
    date(val) {
      this.addedItem.dateFormat = this.formatDate(this.date);
    },
  },
};
</script>
<style scoped>

</style>
